import { bind, h, tag } from "omi";

import { NWDraggablePanel } from "@/wc/components/base/nw-draggable-panel";
import { UserHintService } from "@/services/userHintService";
import { PureComponent } from "@/utils/pureComponent.tsx";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

type Props = {};

@tag("app-layout")
export class AppLayout extends PureComponent<Props> {
  static css = [tailwind];
  private userHintService = new UserHintService();

  @bind
  private handlePanelVisibilityChange(isVisible: boolean) {
    if (isVisible && this.userHintService.shouldSeeHint("portfolio_drag")) {
      this.userHintService.markHintAsSeen("portfolio_drag");
      this.updateSelf();
    }

    if (isVisible) {
      window.history.pushState({}, "", "/portfolio");
      Store.app.setRoute("portfolio");
    } else {
      window.history.pushState({}, "", `/projects/${Store.project.id.value}`);
      Store.app.setRoute("project");
    }
  }

  render() {
    const showDragHint = this.userHintService.shouldSeeHint("portfolio_drag");

    return (
      <NWDraggablePanel
        fullWidth
        showDragHandle
        onPanelVisibilityChange={this.handlePanelVisibilityChange}
        visible={Store.app.isRouteActive("portfolio")}
        dragHintComponent={
          showDragHint ? (
            <h4 className="hidden lg:flex md:flex-col md:items-center md:justify-start text-xl absolute -right-40 w-40 text-left text-quaternary opacity-60 font-signature text-wrap">
              Drag me and see what happens 👀
            </h4>
          ) : null
        }
      >
        <slot name="panel" slot="panel" />
        <slot name="main" slot="main" />
      </NWDraggablePanel>
    );
  }
}
